import { render } from "./UserProfileCardEditorReauthenticate.vue?vue&type=template&id=06b96f72"
import script from "./UserProfileCardEditorReauthenticate.vue?vue&type=script&lang=js"
export * from "./UserProfileCardEditorReauthenticate.vue?vue&type=script&lang=js"
script.render = render

export default script